import { render, staticRenderFns } from "./SFuel.vue?vue&type=template&id=144c27cc&scoped=true&"
import script from "./SFuel.vue?vue&type=script&lang=ts&"
export * from "./SFuel.vue?vue&type=script&lang=ts&"
import style0 from "./SFuel.vue?vue&type=style&index=0&id=144c27cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c27cc",
  null
  
)

export default component.exports